import PropTypes from 'prop-types';
import React from 'react';
import DatePicker from 'react-datepicker';

import BaseInput from 'components/shared/controls/BaseInput';

const DateInput = ({
  name,
  placeholder,
  disabled,
  dateFormat,
  minDate,
  maxDate,
  value,
  onBlur,
  onChange,
  ...restProps
}) => {
  const handleChange = (date) => {
    onChange && onChange({ target: { name, value: date } });
  };

  return (
    <DatePicker
      closeOnScroll
      showYearDropdown
      popperPlacement="top"
      disabled={disabled}
      placeholderText={placeholder}
      dateFormat={dateFormat}
      minDate={minDate}
      maxDate={maxDate}
      selected={value}
      onChange={handleChange}
      onBlur={onBlur}
      customInput={<BaseInput name={name} {...restProps} />}
    />
  );
};

DateInput.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  dateFormat: PropTypes.string,
  value: PropTypes.object,
  minDate: PropTypes.object,
  maxDate: PropTypes.object,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export default DateInput;
